import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { Flex } from 'shared/ui/flex';
import { FC, Fragment, useEffect, useState } from 'react';
import { formatDuration, formatTime } from 'shared/lib/time';
import flash from 'assets/icons/flash.svg';

import { TextCard } from 'shared/ui/cards/textCard';
import { formatWithLocale } from 'shared/lib/datepicker';
import { MarginBottom } from './styles';
import { Order } from 'entities/orders';

export const OrderTimeInfo: FC<{ order: Order | null }> = ({ order }) => {
	const EnhancedTypography = withTypographyContainer(Typography);
	const [visitStart, setVisitStart] = useState('');
	const [visitTime, setVisitTime] = useState('');

	useEffect(() => {
		if (order) {
			if (order.dt_start) {
				const start = formatTime({ time: order.dt_start });
				const end = formatTime({ time: order.dt_end });
				if (start && end) {
					setVisitStart(
						`${formatWithLocale(
							new Date(order.dt_start),
							'd MMM (EEEEEE)',
						)}`,
					);
					setVisitTime(`${start.time} - ${end.time}`)
				}
			}
		}
	}, [order]);

	return (
		<Fragment>
			{order && (
				<MarginBottom>
					<Flex $wrap="wrap" $gap="11px">
						<div>
							<EnhancedTypography mode="small">
								Дата
							</EnhancedTypography>
							<TextCard padding="3px" mode="small">{visitStart}</TextCard>
						</div>
						<div>
							<EnhancedTypography mode="small">
								Время
							</EnhancedTypography>
							<TextCard padding="3px" mode="small">{visitTime}</TextCard>
						</div>
						{visitStart && order.duration && (
							<div>
								<EnhancedTypography mode="small">
									Период
								</EnhancedTypography>
								<TextCard padding="3px" mode="small">
									{formatDuration(
										order.appointment?.dt_visit_start ||
										order.dt_start,
										order.duration,
										true
									)}
								</TextCard>
							</div>
						)}
						{order.participants_count && (
							<div>
								<EnhancedTypography mode="small">
									Гости
								</EnhancedTypography>
								<TextCard padding="3px 15px" mode="small">
									<Flex $alignItems="center">
										{order.appointment?.bypass && <img src={flash} style={{ marginRight: '2px' }} />}
										{order.participants_count}
									</Flex>
								</TextCard>
							</div>
						)}
					</Flex>
				</MarginBottom>
			)}
		</Fragment>
	);
};
